module.exports = "../images/the-patricia-ear-falls-waterfront.jpg?v=79b1bb7";